import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

interface WrapperProps {
  isOpen: boolean;
}

interface FilterItemProps {
  isActive?: boolean;
  hoverTextColor?: string;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;

  position: relative;

  background: rgba(242, 242, 242, 0.14);
  backdrop-filter: blur(8px);

  overflow: hidden;

  ${({ isOpen }) =>
    isOpen
      ? `
      align-items: left;

      position: absolute;
      left: 28px;
      right: 27px;
      min-width: 300px;
      bottom: 28px;
      border-radius: 28px;
      padding: 28px 20px;
      z-index: ${layout.zIndex.filter};
  `
      : `
      align-items: center;

      border-radius: 40px;
      padding: 8px 8px 8px 20px;
  `};

  ${mediaTablet(`
    width: fit-content;
  `)};
`;

export const MainContent = styled(motion.div)`
  display: flex;
  align-items: center;
`;

export const FilterHeading = styled(motion.div)`
  margin: 0 0 16px;
  padding: 0 16px;

  svg {
    width: 22.56px;

    color: ${colors.white};

    position: absolute;
    top: 26px;
    right: 26.2px;

    cursor: pointer;
  }
`;

export const ActiveFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 0 8px;
  padding: 8px 16px;

  border-radius: 33px;
  background: ${colors.concrete};

  cursor: pointer;
`;

export const OpenModalWrapper = styled(motion.div)``;

export const FiltersWrapper = styled.ul`
  display: flex;
  flex-direction: column;

  & > :not(li:last-child) {
    margin: 0 0 4px;
  }
`;

export const FilterItem = styled(motion.li)<FilterItemProps>`
  width: fit-content;

  padding: 8px 16px;
  border-radius: 33px;
  transition: background-color 0.3s linear;

  p {
    transition: color 0.3s linear;
  }

  ${({ isActive, hoverTextColor }) =>
    isActive
      ? `
      background: ${colors.concrete};
      p {
        color: ${colors.lighterMineShaft};
      }
  `
      : `
    &:hover {
      background-color: rgba(242, 242, 242, 0.1);
      ${
        hoverTextColor?.length &&
        `
          p {
            color: ${colors[hoverTextColor] ?? hoverTextColor};
          }
        `
      }
    }
  `}

  cursor: pointer;
`;
